export { default as CatalogoRegraDeCalculo } from './apresentacao/CatalogoRegraDeCalculo.vue'
export { usarCatalogoRegraDeCalculo } from './apresentacao/usar-catalogo-regra-de-calculo'
export {
  CHAVE_OPERACOES_CATALOGO_REGRA_DE_CALCULO,
  usarOperacoesCatalogoRegraDeCalculo,
} from './apresentacao/catalogo-regra-de-calculo.injecao'
export { DESCRITOR_CATALOGO_REGRA_DE_CALCULO } from './catalogo-regra-de-calculo.tipos'
export type {
  FiltrosCatalogoRegraDeCalculo,
  OpcaoRegraDeCalculo,
  OperacoesCatalogoRegraDeCalculo,
  SelecaoCatalogoRegraDeCalculo,
} from './catalogo-regra-de-calculo.tipos'
